__turbopack_context__.v({
  "className": "montserrat_f45d39f8-module__I3017a__className",
  "variable": "montserrat_f45d39f8-module__I3017a__variable",
});
